import classes from "./AdTab.module.scss";
import { AdTabProps } from "./config/tab";
import { memo } from "react";

const AdTab = ({ link, label }: AdTabProps) => {
  return (
    <a className={classes.adTab} href={link}>{label}</a>
  );
};

const adTabMemo = memo(AdTab);

export default adTabMemo;
